import gsap, {Linear} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
// import {debounce} from 'throttle-debounce';
import initScrollTrigger from '../helpers/initScrollTrigger';

import accordeon from '../helpers/accordeon';

import {getSimplePlayer, initScrollAutoplayVideo} from '../components/video';
import { initLines } from './line-ticker';

import сustomPageScroll from './custom-scroll';

import {IS_PHONE, BREAKPOINTS, CLASSES} from '../helpers/consts';
import isPortrait from '../helpers/isPortrait';
import refreshScrollAndTriggers from '../helpers/refreshScrollTriggers';

gsap.registerPlugin(ScrollTrigger);


const getMaxHeight = (elements) => {
	let maxHeight = 0;

	for (let i = 0; i < elements.length; i++) {
		const elementHeight = elements[i].offsetHeight;
		maxHeight = Math.max(maxHeight, elementHeight);
	}
	return maxHeight;
};


export default () => {
	if(IS_PHONE) return;

	initScrollTrigger();

	const section = document.querySelector('.js-text-slider-section');
	if(!section) return;
	// const bottomGradientEl = document.querySelector('.js-about-dinamic-gradient');
	const wrapper = section.querySelector('.js-text-slider-section-inner');
	const fixedBlock = section.querySelector('.js-text-slider-section-fixed-block');
	const fixedItems = section.querySelectorAll('.js-text-slider-section-fixed-item');
	const placeholderBlocks = section.querySelectorAll('.js-text-slider-section-placeholder-item');

	const trigger = ScrollTrigger.create({
		trigger: wrapper,
		scrub: 0.5,
		pin: fixedBlock,
		pinSpacing: false,
		start: 'top top',
		end: () => {
			// if(isPortrait()) {
			// 	const blockH = wrapper.getBoundingClientRect().height;
			// 	const maxElemsHeight = getMaxHeight(fixedItems);

			// 	return `${blockH + maxElemsHeight} bottom`;
			// }
			return 'bottom bottom';
		},
	});

	const changeFixedItems = (activeItem) => {

		fixedItems.forEach((item) => {
			item.classList.remove(CLASSES.active);
		});
		activeItem.classList.add(CLASSES.active);
	};

	placeholderBlocks.forEach((block, i) => {
		const fixItem = fixedItems[i];

		const trigger = ScrollTrigger.create({
			trigger: block,
			start: 'top 50%',
			// start: 'top top',
			end: 'bottom bottom',
			onEnter: () => {
				changeFixedItems(fixItem);

			},
			onLeaveBack: () => {
				if(i === 0) {
					changeFixedItems(fixedItems[0]);
				}
				else {
					changeFixedItems(fixedItems[i - 1]);
				}
			},
		});
	});

};
